import {track} from 'iq-tracking';

// Mirrors the event name used in the main frontend for consistency.
export const trackCompanyClicked = (slug: string): Promise<void> =>
  track({
    event: 'click_interviews_interview_guide',
    action: 'click',
    component: 'card',
    content_type: 'interview',
    content_identifier: slug,
  });

// Fired from the /companies feed cards (both locked and unlocked) — separate from
// trackCompanyClicked (the legacy /companies/all directory grid) since these are two
// different entry points into the same guide, and `locked` distinguishes a
// share-to-unlock click from a direct guide view.
export const trackFeedCardClicked = (item: {id: string; company_slug: string; is_locked: boolean}): Promise<void> =>
  track({
    event: 'companies_feed_card_clicked',
    action: 'click',
    component: 'card',
    content_type: 'interview',
    content_identifier: item.company_slug,
    extra: {extra_data: JSON.stringify({experience_id: item.id, locked: item.is_locked})},
  });

export const trackRightRailCompanyClicked = (slug: string): Promise<void> =>
  track({
    event: 'companies_right_rail_company_clicked',
    action: 'click',
    component: 'sticky sidebar',
    content_type: 'interview',
    content_identifier: slug,
  });

export const trackRightRailAllCompaniesClicked = (): Promise<void> =>
  track({
    event: 'companies_right_rail_all_clicked',
    action: 'click',
    component: 'sticky sidebar',
    content_type: 'companies',
  });

// Distinct from trackCompaniesSearched (the /companies/all grid filter) — this is the
// /companies hero typeahead, a different component hitting a different endpoint
// (GET /v1/companies/search vs /v2/companies).
export const trackHeroSearchResultClicked = (type: string, slug: string): Promise<void> =>
  track({
    event: 'companies_hero_search_result_clicked',
    action: 'click',
    component: 'header',
    content_type: type,
    content_identifier: slug,
  });

export const trackContributionModuleClicked = (): Promise<void> =>
  track({
    event: 'companies_contribution_module_clicked',
    action: 'click',
    component: 'sticky sidebar',
    content_type: 'submit_experience',
  });

// Mirrors the event name used in the main frontend for consistency.
export const trackCompaniesSearched = (query: string): Promise<void> =>
  track({
    event: 'update_companies_form',
    action: 'search',
    content_type: 'companies',
    extra: {extra_data: JSON.stringify({query})},
  });
